import React, { FC, useEffect, useState } from 'react';

import ModalSettings from '../../../ModalSettings';
import { generateListKeys, prepareData } from '../../../../../../../helpers/utils/reports';
import { useActions } from '../../../../../hooks/useActions';
import { useTypedSelector } from '../../../../../hooks/useTypedSelector';

interface MetricsProps {
    isDisable?: boolean;
    metricsData: any[];
}

/**
 * Специализированный компонент метрик для table-report.
 * Использует унифицированный ModalSettings с simplified=true.
 * Особенности: динамические metricsData через props, localStorage, отдельный Redux state.
 */
const Metrics: FC<MetricsProps> = ({ isDisable, metricsData }) => {

    const { metricsReport } = useTypedSelector((state) => state.table);
    const { setReportMetrics, setMetaTableFetching } = useActions();

    const [ listKeysMetrics, setListKeysMetrics ] = useState<any[]>([]);
    const [ data, setData ] = useState<any[]>([]);

    useEffect(() => {
        const preparedData = prepareData(metricsData, '', [], false);
        setData(preparedData);
        setListKeysMetrics(generateListKeys(preparedData));
        if(!location.pathname.includes('users')){
            setReportMetrics(preparedData);
            return;
        }
        const selectedMetrics = window.localStorage.getItem(`tableMetricsItemSelected_${location.pathname}`);
        if (selectedMetrics) {
            setReportMetrics(JSON.parse(selectedMetrics));
        } else {
            window.localStorage.setItem(`tableMetricsItemSelected_${location.pathname}`, JSON.stringify(preparedData));
            setReportMetrics(preparedData);
        }
    }, []);

    const actionSet = (selected: any) => {
        window.localStorage.setItem(`tableMetricsItemSelected_${location.pathname}`, JSON.stringify(selected));
        setReportMetrics(selected);
        setMetaTableFetching({ value: true });
    };

    return (
        <ModalSettings
            title="Метрики"
            dataItems={data}
            listKeys={listKeysMetrics}
            defSelected={metricsReport}
            defChecked={metricsReport.map((item: any) => item.key)}
            isDisable={isDisable}
            actionSet={actionSet}
            simplified={true}
            enableCustomMetrics={false}
            enableLazyLoading={false}
            modalWidth={800}
        />
    );
};

export default Metrics;
